import store from '@/store';
import UtilitiesApi from "@/api/utilities/UtilitiesApi";

export const AppVersionHelper = {
    async getCurrentVersionInfo(){
        window.console.log('HIT V-CHECK');
        let info = await UtilitiesApi.getVersionInfo()
            .then(response => {
                return response.data
            }).catch(() => {
                return undefined
            });

        if(
            (info.minimum_required_version !== undefined && info.minimum_required_version !== null) &&
            (info.latest_version !== undefined && info.latest_version !== null)
        ) {
            await store.dispatch('setWebAppVersionInformation', info);
        }
    },
    isNewerVersion (oldVer, newVer) {
        const oldParts = oldVer.split('.')
        const newParts = newVer.split('.')
        for (var i = 0; i < newParts.length; i++) {
            const a = ~~newParts[i] // parse int
            const b = ~~oldParts[i] // parse int
            if (a > b) return true
            if (a < b) return false
        }
        return false
    }
}